import {createSlice} from "@reduxjs/toolkit";
import {setUIDVIRSearchFilter} from "./actions";
import {DVIRSearchCriteria} from "@ots-frontend/ots-data";

type DVIRUIState = {
  searchFilter?: DVIRSearchCriteria
}

const INITIAL_STATE: Readonly<DVIRUIState> = {};

const dvirUISlice = createSlice({
  name: "ots-ui/dvir",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIDVIRSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const dvirUIReducer = dvirUISlice.reducer;
